/** Em que plataforma cada usuário entra (02/11/2026), pedido do dono: o superusuário
 *  entra nas duas, o HubTransGrãos e o HubVerticalFarm; o operador da equipe entra
 *  onde o cargo ou as áreas próprias dão área; o usuário de cliente só no portal.
 *
 *  É a mesma derivação do servidor para o `hubs` da sessão, `hubsDasAreas` sobre as
 *  áreas efetivas. Quando a resposta já traz `hubs`, vale ela. */
import { ehSuperusuario, hubsDasAreas } from '../../core/areas/acesso'
import { HUBS, type HubKey } from '../../core/hubs/hubs'
import type { Usuario } from '../../core/api/types'

export interface PlataformasDoUsuario {
  superusuario: boolean
  /** Cliente não entra em hub: usa o portal do cliente. */
  cliente: boolean
  hubs: HubKey[]
}

type Alvo = Pick<Usuario, 'is_staff' | 'role' | 'is_superuser' | 'hubs' | 'areas' | 'areas_do_cargo' | 'areas_proprias'>

export function plataformasDoUsuario(u: Alvo): PlataformasDoUsuario {
  if (ehSuperusuario(u)) return { superusuario: true, cliente: false, hubs: HUBS.map((h) => h.key) }
  if (!u.is_staff) return { superusuario: false, cliente: true, hubs: [] }
  const areas = u.areas ?? [...(u.areas_do_cargo ?? []), ...(u.areas_proprias ?? [])]
  return { superusuario: false, cliente: false, hubs: u.hubs ?? hubsDasAreas(areas) }
}
